import { FC } from 'react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';
import { AppDispatch } from 'app/store';
import { removeSongCollaboratorEffect } from 'app/store/SongList/effects';
import { Collaborator } from 'types/collaborator.types';

export interface RemoveCollaboratorDialogProps {
  open: boolean;
  dispatch: AppDispatch;
  onClose: () => void;
  collaborator?: Collaborator;
}

export const RemoveCollaboratorDialog: FC<RemoveCollaboratorDialogProps> = ({
  dispatch,
  onClose,
  open,
  collaborator,
}) => {
  const handleRemove = async () => {
    if (collaborator) {
      await dispatch(removeSongCollaboratorEffect({ collaborator }));
      onClose();
    }
  };

  return (
    <ChakraConfirmationDialog
      title="Remove Collaborator"
      actionButtonText="Remove"
      handleAction={handleRemove}
      isOpen={open}
      onClose={onClose}
      message={`Are you sure you want to remove ${
        collaborator?.profile?.displayName || collaborator?.inviteeEmail
      } as 
      a collaborator?`}
    />
  );
};
